import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

function __Totals(props) { return <LabelValue {...props} collapseLabelIfEmpty={true} collapseValueIfEmpty={true} value={props.content} /> }
const _Totals = withLabelTokenParsing(__Totals, (props, keyword, options) => {
    const data = props.data || {};
    const visibility = props.visibility || {};
    if (!props.forceVisibility && !props.builder && visibility[keyword] == false) {
        return '';
    }
    let replaceString = '';
    switch (keyword) {
        case Token.Total.Consignment:
            if (data.TotalConsignment != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.TotalConsignment, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        case Token.Total.Retail:
            if (data.TotalRetail != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.TotalRetail, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
}, { allowEmptyContent: true });
function Totals(props) {
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    return <_Totals {...props} allowEmptyValue={true} visibility={props.config && props.config.config && props.config.config.Visibility} visibilityHash={visibilityHash} />
}
const Tokens = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Consignment Total', defaultValue, Token.Total.Consignment),
        Token.getCurrencyTokenConfig('Retail Total', defaultValue, Token.Total.Retail)
    ]
};
const TypeConfig = {
    panel: {
        block: () => LabelValueTypeConfig.panel.block(3),
        description: () => LabelValueTypeConfig.panel.description(Utilities.wrapTextForEditor({ tag: Name.Stylesheet.Header2, text: 'Totals' })),
        label: (data) => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: `{${Token.Total.Retail}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Retail })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Consignment}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Consignment })),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Retail Total', name: Token.Total.Retail, type: 'checkbox', value: true, configurableDuringExport: (_, config, blockType) => Token.isTokenPresent(Token.Total.Retail, { ...config, type: blockType }, Name.Block.Consignment.Totals) },
                    { display: 'Consignment Total', name: Token.Total.Consignment, type: 'checkbox', value: true, configurableDuringExport: (_, config, blockType) => Token.isTokenPresent(Token.Total.Consignment, { ...config, type: blockType }, Name.Block.Consignment.Totals) }
                ],
                visible: () => false
            };
        }
    }
};

export {
    Totals as Component,
    Tokens,
    TypeConfig
};